<template>
  <div>
    <div class="pa-6">
      <v-container fluid>
        <v-row>
          <v-col class="yCenter">
            <h2 class="primary--text pr-5">
              {{ $t('nextengine.nextengine_ec-receiveorder-list') }}
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <NoneChevronExpansionPanel>
              <template #header>
                <div class="headerAreaStyle d-flex align-center px-9">
                  <div class="titleStyle">
                    {{ $t('sale.sale_history-search') }}
                  </div>
                  <div class="ml-5">
                    <v-checkbox
                      v-model="invalidDisplayFlg"
                      :label="
                        $t(
                          'nextengine.nextengine_ec-receiveorder-hidden-sale-registerd'
                        )
                      "
                    />
                  </div>
                </div>
              </template>
              <template #content>
                <div class="mx-5 mb-5 mt-2">
                  <div class="pa-2">
                    <v-row no-gutters>
                      <v-col cols="8">
                        <InputFormNew
                          :value="inputData"
                          :detail="items"
                          :titleCols="inputFormStyle.titleCols"
                          :contentsCols="inputFormStyle.contentsCols"
                        >
                        </InputFormNew>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </template>
            </NoneChevronExpansionPanel>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <EcReceiveorderInfo
              ref="ecReceiveorderInfo"
              :search="ecReceiveorderSearchInfo"
              @detail="detail"
              @register="register"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <EcReceiveorderDialog
      v-model="dialogInfo.detail"
      :ecReceiveorderData="ecReceiveorderData"
    />
    <EcReceiveorderRegisterDialog
      v-model="dialogInfo.register"
      :ecReceiveorderLists="ecReceiveorderRegisterData"
      @detail="detail"
      @registration-successful="handleRegistrationSuccess"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Master } from '@/components/layouts'
import {
  EcReceiveorderDialog,
  EcReceiveorderRegisterDialog
} from '@/components/layouts/Dialogs'
import EcReceiveorderInfo from '@/components/layouts/Nextengine/EcReceiveorder/EcReceiveorderInfo'
import { NoneChevronExpansionPanel } from '@/components/items'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import { NormalButton } from '@/components/items'
import { i18n } from '@/main.js'
export default {
  components: {
    Master,
    EcReceiveorderDialog,
    EcReceiveorderRegisterDialog,
    EcReceiveorderInfo,
    NoneChevronExpansionPanel,
    InputFormNew,
    NormalButton
  },
  data: () => {
    return {
      pageTitle: 'master.product_product-manage',
      buttonName: 'order.order_product-registration',
      ecReceiveorderData: {},
      ecReceiveorderRegisterData: [],
      itemKey: 'productId',
      dialogInfo: {
        register: false,
        edit: false,
        detail: false
      },
      editMode: false,
      ecReceiveorderSearchInfo: {
        keyword: '',
        category: '',
        isEnabled: true,
        importDate: {},
        receiveOrderId: '',
        receiveOrderShopCutFormId: '',
        invalidDisplayFlg: true
      },
      invalidDisplayFlg: true,
      inputData: {
        importDate: { start: '', end: '' },
        receiveOrderId: '',
        receiveOrderShopCutFormId: ''
      },
      lastValidImportDate: { start: '', end: '' },
      inputFormStyle: {
        titleCols: 3,
        contentsCols: 7,
        inputItemHeight: '32px'
      },
      items: [
        {
          text: i18n.tc('nextengine.nextengine_import-date'),
          name: 'importDate',
          component: 'FromToDatePicker'
        },
        {
          name: 'receiveOrderId',
          text: i18n.tc('nextengine.nextengine_ec-receiveorder-receiveorder-id')
        },
        {
          name: 'receiveOrderShopCutFormId',
          text: i18n.tc(
            'nextengine.nextengine_ec-receiveorder-receiveorder-shop-cut-form-id'
          )
        }
      ]
    }
  },
  created() {
    // １週間前の日付を取得
    const today = new Date()
    const oneWeekAgo = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7
    )
    // 日付をYYYY-MM-DD形式の文字列に変換
    const formatDate = (date) => {
      const y = date.getFullYear()
      const m = ('00' + (date.getMonth() + 1)).slice(-2)
      const d = ('00' + date.getDate()).slice(-2)
      return `${y}-${m}-${d}`
    }
    const startDate = formatDate(oneWeekAgo)
    const endDate = formatDate(today)

    // inputDataとlastValidImportDateの両方に初期値を設定
    this.inputData.importDate.start = startDate
    this.inputData.importDate.end = endDate
    this.lastValidImportDate.start = startDate
    this.lastValidImportDate.end = endDate
  },
  watch: {
    inputData: {
      handler(newVal) {
        const startDate = newVal.importDate.start
        const endDate = newVal.importDate.end

        // 履歴検索欄のバリデーション処理
        // 開始日と終了日の両方が入力済みで、開始日が終了日より後の場合
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
          alert('開始日は終了日以前の日付を選択してください。')
          // $nextTickを使い、DOM更新後の値クリアを保証
          // 直前の有効な値に戻す
          this.$nextTick(() => {
            this.inputData.importDate = { ...this.lastValidImportDate }
          })
          return // 後続の同期処理を中断
        }
        // バリデーションが成功した場合、lastValidImportDateを更新
        this.lastValidImportDate = { ...newVal.importDate }

        // inputDataの変更をecReceiveorderSearchInfoに同期させる
        this.ecReceiveorderSearchInfo.importDate = newVal.importDate
        this.ecReceiveorderSearchInfo.receiveOrderId = newVal.receiveOrderId
        this.ecReceiveorderSearchInfo.receiveOrderShopCutFormId =
          newVal.receiveOrderShopCutFormId
      },
      deep: true // ネストされたオブジェクトの変更も検知
    },
    invalidDisplayFlg(newVal) {
      this.ecReceiveorderSearchInfo.invalidDisplayFlg = newVal
    }
  },
  methods: {
    ...mapGetters('Common', ['getLangFromState']),
    async init() {},
    inputKeyword(...args) {
      const [keyword] = args
      this.ecReceiveorderSearchInfo.keyword = keyword
    },
    selectCategory(...args) {
      const [categoryId] = args
      this.ecReceiveorderSearchInfo.category = categoryId
    },
    inputIsEnabled(...args) {
      const [isEnabled] = args
      this.ecReceiveorderSearchInfo.isEnabled = isEnabled
    },
    async detail(ecReceiveorderData) {
      this.ecReceiveorderData = ecReceiveorderData
      this.dialogInfo.detail = true
    },
    async register(ecReceiveorderLists) {
      this.ecReceiveorderRegisterData = ecReceiveorderLists
      this.dialogInfo.register = true
    },
    handleRegistrationSuccess(successfulOrderIds) {
      // 1. 子コンポーネントのメソッドを呼び出して画面のステータスを更新
      if (this.$refs.ecReceiveorderInfo) {
        this.$refs.ecReceiveorderInfo.updateStatusByIds(successfulOrderIds)
      }
      // 2. 処理が完了したので、ダイアログを閉じる
      this.dialogInfo.register = false
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    }
  },
  computed: {
    ...mapGetters('User', ['authority'])
  }
}
</script>
<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.headerAreaStyle {
  height: 70px;
}
.rightBtn {
  display: flex;
  justify-content: flex-end;
}
</style>
